export const Logo = ({ size = 'default', variant = 'dark', showText = true }) => {
  const sizeClasses = {
    small: 'h-7 w-7',
    default: 'h-9 w-9',
    large: 'h-12 w-12'
  };

  const textClasses = {
    small: 'text-lg',
    default: 'text-xl',
    large: 'text-2xl'
  };

  const textColor = variant === 'light' ? 'text-white' : 'text-foreground';

  return (
    <div className="flex items-center gap-2.5">
      <div className={`${sizeClasses[size]} relative`}>
        {/* Gradient background circle */}
        <div className="absolute inset-0 rounded-xl bg-gradient-to-br from-blue-500 to-purple-600 opacity-90" />
        {/* Icon */}
        <svg 
          viewBox="0 0 24 24" 
          fill="none" 
          className="relative w-full h-full p-1.5"
        >
          {/* House shape */}
          <path 
            d="M3 10.5L12 3L21 10.5V20C21 20.5523 20.5523 21 20 21H4C3.44772 21 3 20.5523 3 20V10.5Z" 
            fill="white"
            fillOpacity="0.9"
          />
          {/* Sparkle/AI element */}
          <path 
            d="M12 8L13 11L16 12L13 13L12 16L11 13L8 12L11 11L12 8Z" 
            fill="url(#sparkle-gradient)"
          />
          <defs>
            <linearGradient id="sparkle-gradient" x1="8" y1="8" x2="16" y2="16">
              <stop stopColor="#3B82F6" />
              <stop offset="1" stopColor="#8B5CF6" />
            </linearGradient>
          </defs>
        </svg>
      </div>
      {showText && (
        <div className="flex flex-col leading-none">
          <span className={`font-heading font-bold tracking-tight ${textClasses[size]} ${textColor}`}>
            ListingPro
          </span>
          <span className="text-xs font-semibold tracking-widest text-gradient uppercase">
            AI
          </span>
        </div>
      )}
    </div>
  );
};

export default Logo;
